/** API 베이스 URL.
 * 개발(npm start): `http(s)://접속한호스트:4000/api` 직접 호출.
 * 운영(build): 기본 `/api` (nginx reverse-proxy 권장), 필요 시 `REACT_APP_API_BASE_URL`로 오버라이드.
 */
export const getApiBaseUrl = () => {
    const fromEnv = String(process.env.REACT_APP_API_BASE_URL || '').trim().replace(/\/+$/, '');
    if (fromEnv) {
        // HTTPS 페이지에서 http API를 강제로 막아 Mixed Content 오류를 예방한다.
        if (typeof window !== 'undefined' && window.location?.protocol === 'https:' && /^http:\/\//i.test(fromEnv)) {
            return '/api';
        }
        return fromEnv;
    }
    if (process.env.NODE_ENV === 'development') {
        if (typeof window !== 'undefined' && window.location && window.location.hostname) {
            const rawPort = String(process.env.REACT_APP_DEV_API_PORT || '4000').trim();
            const devPort = /^\d+$/.test(rawPort) ? rawPort : '4000';
            const { protocol } = window.location;
            const { hostname } = window.location;
            // localhost는 127.0.0.1로 고정(Windows에서 ::1 vs IPv4 백엔드 불일치 완화). LAN IP는 그대로.
            const host =
                hostname === 'localhost' || hostname === '[::1]' ? '127.0.0.1' : hostname;
            return `${protocol}//${host}:${devPort}/api`;
        }
        return '/api';
    }
    return '/api';
};

/** fetch 응답 본문을 JSON으로 읽음. HTML·비JSON이면 명확한 오류(Unexpected token '<' 방지). */
export async function readJsonResponse(response) {
    const rawText = await response.text();
    const trimmed = rawText.trim();
    if (trimmed.startsWith('<')) {
        throw new Error(
            '서버가 JSON 대신 HTML을 반환했습니다. API 서버(`node server/index.js`, 포트 4000)와 DB 연결을 확인해주세요.'
        );
    }
    let data;
    try {
        data = trimmed ? JSON.parse(trimmed) : null;
    } catch (e) {
        throw new Error(`서버 응답을 JSON으로 읽을 수 없습니다 (HTTP ${response.status}).`);
    }
    if (!response.ok) {
        const msg = (data && (data.message || data.error)) || `요청 실패 (HTTP ${response.status})`;
        throw new Error(msg);
    }
    return data;
}
